import { render } from "./problems.vue?vue&type=template&id=3846f857&scoped=true"
import script from "./problems.vue?vue&type=script&lang=js"
export * from "./problems.vue?vue&type=script&lang=js"

import "./problems.vue?vue&type=style&index=0&id=3846f857&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3846f857"]])

export default __exports__